import { render, staticRenderFns } from "./AdminSliderSupplier.vue?vue&type=template&id=55f3df4e&scoped=true&"
import script from "./AdminSliderSupplier.vue?vue&type=script&lang=js&"
export * from "./AdminSliderSupplier.vue?vue&type=script&lang=js&"
import style0 from "./AdminSliderSupplier.vue?vue&type=style&index=0&id=55f3df4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f3df4e",
  null
  
)

export default component.exports